import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/collectible-card-total-background-large.svg'
import _imports_1 from '@/app/ui/assets/svg/arrow-left.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-79ee4b58")

_pushScopeId("data-v-79ee4b58")
const _hoisted_1 = {
  class: "flex flex-col h-screen overflow-scroll bg-white",
  style: {"min-height":"100%"}
}
const _hoisted_2 = {
  key: 1,
  class: "relative flex justify-center items-center"
}
const _hoisted_3 = { class: "absolute flex flex-col justify-center items-center" }
const _hoisted_4 = {
  key: 1,
  class: "relative"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_6 = { class: "absolute inset-0 z-20 text-12px font-montserrat text-white text-shadow-border text-center mt-0.5" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5 mr-3 cursor-pointer text-red-lp-2000",
  alt: "left"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-12px mr-4 text-red-lp-2000" }, " Kembali ", -1)
const _hoisted_9 = { class: "font-bold text-34px pl-5 text-black-lp-200" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "h-screen" }, null, -1)
const _hoisted_11 = { class: "sticky bottom-0 p-5 border-t bg-white" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", {
  class: "absolute w-full bg-white",
  style: {"bottom":"-20px","margin-left":"-20px","height":"70px","z-index":"-1"}
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_LpButton = _resolveComponent("LpButton")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Skeleton, {
          key: 0,
          class: "absolute",
          style: {"z-index":"999"},
          width: "100%",
          height: "500px"
        }))
      : (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("img", {
            src: 
                `${
                    _ctx.detailCollectibleCard?.imageUrl
                    ? require(`@/app/ui/assets/images/bg-detail-card.png`)
                    : require(`@/app/ui/assets/images/collectible-card-error-image.png`)
                }`
                ,
            alt: "Detail Photocard",
            class: "w-full"
          }, null, 8, ["src"]),
          _createVNode("div", _hoisted_3, [
            (_ctx.detailCollectibleCard?.imageUrl && !_ctx.isImageError)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _ctx.localPhotoCard,
                  onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImageError && _ctx.onImageError(...args))),
                  onLoad: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onImageLoaded && _ctx.onImageLoaded(...args))),
                  alt: "Detail Photocard",
                  class: "w-250px rounded-lg"
                }, null, 40, ["src"]))
              : _createCommentVNode("", true),
            (_ctx.detailCollectibleCard?.grade === 'SILVER' && !_ctx.isImageStillLoading && !_ctx.isImageError)
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode("div", _hoisted_6, " X" + _toDisplayString(_ctx.detailCollectibleCard?.total), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])),
    _createVNode("div", {
      class: "flex flex-row pl-5 my-4",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
    }, [
      _hoisted_7,
      _hoisted_8
    ]),
    _createVNode("div", _hoisted_9, _toDisplayString(_ctx.detailCollectibleCard?.grade) + " Digital Photocard " + _toDisplayString(_ctx.detailCollectibleCard?.grade === 'SILVER' ? _ctx.detailCollectibleCard?.imageId : ''), 1),
    _hoisted_10,
    _createVNode("div", _hoisted_11, [
      _hoisted_12,
      _createVNode(_component_LpButton, {
        isWidthFull: "",
        title: "Download",
        color: "black",
        textColor: "white",
        rounded: "",
        fontBold: "",
        disabled: _ctx.isLoading || _ctx.detailCollectibleCard?.imageUrl === '',
        onClick: _ctx.downloadImage
      }, null, 8, ["disabled", "onClick"])
    ])
  ]))
})